import type { PasteMetadata, ClipboardItem } from '../../common/types';

export const getFieldMetadataFromClipboard = (clipboard: ClipboardItem): PasteMetadata | null => {
	if (!clipboard?.html) {
		return null;
	}

	try {
		const clipboardDocument = new DOMParser().parseFromString(clipboard.html, 'text/html');
		const data = clipboardDocument.body?.querySelector('div')?.dataset;

		if (!data || !data.fieldType || !data.fieldId) {
			return null;
		}

		return {
			fieldType: data.fieldType,
			fieldId: data.fieldId,
			fieldValue: data.fieldValue ? JSON.parse(data.fieldValue) : null,
			sourceIssueTypeLevel: data.issueTypeLevel,
		};
	} catch (e) {
		return null;
	}
};

export const notImplemented = () => Promise.resolve(false);
